/**
 * Dessins en pixels du thème Rétro 8 bits (un caractère = un pixel). Dessins originaux, génériques : une console de salon, une
 * console portable, une manette à croix, une cartouche, un cœur, une pièce, un nuage. Aucun élément d'un jeu ou d'une marque.
 */
export const DESSINS = {
    console: [
        "..................",
        ".################.",
        "##..............##",
        "##.#####..##....##",
        "##..............##",
        ".################.",
        "..#............#..",
        "..################",
    ],
    portable: [
        ".############.",
        "##..........##",
        "##.########.##",
        "##.########.##",
        "##.########.##",
        "##..........##",
        "##.#...##...##",
        "#.###.#..#..##",
        "##.#...##...##",
        ".############.",
    ],
    manette: [
        "..############..",
        ".##############.",
        "####.######.####",
        "###...####.#.###",
        "####.######.####",
        "####.######...##",
        ".###########.##.",
        "..###......###..",
    ],
    cartouche: [
        ".##########.",
        "##........##",
        "##.######.##",
        "##.#....#.##",
        "##.######.##",
        "##........##",
        "############",
        "#.#.#.#.#.#.",
    ],
    coeur: [
        ".##..##.",
        "########",
        "########",
        "########",
        ".######.",
        "..####..",
        "...##...",
    ],
    piece: [
        "..####..",
        ".######.",
        "###..###",
        "###..###",
        "###..###",
        ".######.",
        "..####..",
    ],
    nuage: [
        "....####........",
        "...######..###..",
        ".##########.####",
        "################",
        ".##############.",
    ],
};

export const NOMS_OBJETS = ["console", "portable", "manette", "cartouche"];
